import m from "../../geodata/es2015/franceDepartmentsHigh";
window.am4geodata_franceDepartmentsHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/franceDepartmentsHigh.js
// module id = null
// module chunks = 